function ReviewIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
        <circle cx="19" cy="19" r="19" fill="#FF73CB"/>
        <path d="M27 11H11C9.9 11 9.01 11.9 9.01 13L9 31L13 27H27C28.1 27 29 26.1 29 25V13C29 11.9 28.1 11 27 11ZM13 23V20.53L19.88 13.65C20.08 13.45 20.39 13.45 20.59 13.65L22.36 15.42C22.56 15.62 22.56 15.93 22.36 16.13L15.47 23H13ZM25 23H17.5L19.5 21H25V23Z" fill="white"/>
    </svg>
  )
}

export default  ReviewIcon